export default function PainAcelera() {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="container">
        <div className="max-w-4xl mx-auto text-center space-y-12">
          {/* Intro */}
          <div className="space-y-8">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-slate-900 leading-tight">
              Você sente que poderia vender muito mais… <span className="text-orange-600">mas algo trava.</span>
            </h2>
            
            <div className="text-xl text-gray-600 leading-loose space-y-4 mt-12">
              <p>Você investe em marketing…</p>
              <p>Gera alguns leads…</p>
              <p>Fecha algumas vendas…</p>
            </div>
          </div>
          
          {/* Pain Points */}
          <div className="bg-gray-50 rounded-2xl p-12 lg:p-16 border border-gray-200 mt-16">
            <p className="text-2xl font-semibold text-slate-900 mb-12">
              Mas no fundo sabe que:
            </p>
            
            <div className="space-y-6 text-left max-w-2xl mx-auto">
              <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
                <div className="w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0 mt-3"></div>
                <p className="text-lg text-gray-700 leading-relaxed">Não existe previsibilidade</p>
              </div>
              
              <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
                <div className="w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0 mt-3"></div>
                <p className="text-lg text-gray-700 leading-relaxed">O time comercial não tem processo claro</p>
              </div>
              
              <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
                <div className="w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0 mt-3"></div>
                <p className="text-lg text-gray-700 leading-relaxed">O CRM não está organizado (ou nem existe)</p>
              </div>
              
              <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
                <div className="w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0 mt-3"></div>
                <p className="text-lg text-gray-700 leading-relaxed">Leads se perdem por falta de acompanhamento</p>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-1.5 h-1.5 bg-gray-400 rounded-full flex-shrink-0 mt-3"></div>
                <p className="text-lg text-gray-700 leading-relaxed">Você não sabe quanto vai faturar mês que vem</p>
              </div>
            </div>
          </div>
          
          {/* Closing Statement */}
          <div className="space-y-8 pt-12">
            <p className="text-3xl font-semibold text-slate-900">
              E isso cansa.
            </p>
            
            <div className="bg-slate-900 rounded-2xl p-12 border-l-4 border-orange-600">
              <p className="text-xl lg:text-2xl font-medium text-white leading-relaxed">
                Empresas não quebram por falta de clientes.
              </p>
              <p className="text-xl lg:text-2xl font-semibold text-orange-600 mt-3">
                Quebram por falta de estrutura.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
